import React from 'react';
import PropTypes from 'prop-types';

import { IoIcon } from 'components/Icons';
import {
    Body as CardBody,
    Header as CardHeader,
    HeaderButton as CardHeaderButton,
    HeaderButtons as CardHeaderButtons,
    Card as StyledCard,
    Title as CardTitle,
} from './styles';
import {useCardProps} from '../';

const HeaderButton = ({ children, ...rest }) => (
    // defaultProps = { className: null, clickFunc: null, title: null, type: 'button', skin: 'light' };
    <CardHeaderButton {...rest}>{children}</CardHeaderButton>
);

HeaderButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    clickFunc: PropTypes.func,
    skin: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string
};

const ButtonPane = (props) => {
    const { buttons, ...rest } = props;
    const { actions, params: { hasCloseBtn } } = useCardProps();

    return (
        <CardHeaderButtons className='panel__header-buttons' {...rest}>
            {buttons}
            {hasCloseBtn && (
                <>
                    <HeaderButton
                        data-test="eml-grid-close-btn"
                        className='btn-close'
                        onClick={actions.onPanelClose}
                        skin={props.skin}
                    >
                        <IoIcon name="IoMdClose" />
                    </HeaderButton>
                </>
            )}
        </CardHeaderButtons>
    );
};

ButtonPane.propTypes = {
    buttons: PropTypes.element,
    skin: PropTypes.string
};

export const Header = ({ buttons, children,  ...rest }) => {
    const { params: { skin } } = useCardProps();

    return (
        <CardHeader {...{...rest, skin}}>
            {children}
            <ButtonPane buttons={buttons} skin={skin} />
        </CardHeader>
    );
};

Header.propTypes = {
    buttons: PropTypes.element,
    children: PropTypes.node
};

export const Title = ({ children, ...rest }) => (
    <CardTitle {...rest}>{children}</CardTitle>
);

Title.propTypes = { children: PropTypes.node };

export const Body = ({ children, ...rest }) => {
    const { params: { skin } } = useCardProps();

    return (
        <CardBody skin={skin} {...rest}>{children}</CardBody>
    );
};

Body.propTypes = { children: PropTypes.node };

export const Card = ({ children, ...rest }) => {
    const { params } = useCardProps();

    return (
        <StyledCard skin={params.skin} {...rest}>{children}</StyledCard>
    );
};

Card.propTypes = { children: PropTypes.node };
